import {
  createYupSchema,
  IValidationsYupRoot,
  METADATA_KEY,
} from "@ryde/shared";

export type TConfigurationFieldName =
  | "productionAction"
  | "productionType"
  | "shiftIds"
  | "direction"
  | "unitIds"
  | "siteIds"
  | "areaIds"
  | "passengerTypeId"
  | "dayGroupIds"
  | "dayTypeIds"
  | "rideTypeId"
  | "assignDocksDuringProduction"
  | "useCustomDirectionsService"
  | "directionsService";

export const ConfigurationFormFields = {
  productionAction: "productionAction",
  productionType: "productionType",
  shiftIds: "shiftIds",
  direction: "direction",
  unitIds: "unitIds",
  siteIds: "siteIds",
  areaIds: "areaIds",
  passengerTypeId: "passengerTypeId",
  dayGroupIds: "dayGroupIds",
  dayTypeIds: "dayTypeIds",
  rideTypeId: "rideTypeId",
  assignDocksDuringProduction: "assignDocksDuringProduction",
  useCustomDirectionsService: "useCustomDirectionsService",
  directionsService: "directionsService",
} as const satisfies Record<string, TConfigurationFieldName>;

export const configurationFormValidationRules: Record<
  TConfigurationFieldName,
  IValidationsYupRoot
> = {
  productionAction: {
    type: "string",
    rules: [
      {
        validation: "required",
      },
    ],
  },
  productionType: {
    type: "array",
    rules: [],
  },
  shiftIds: {
    type: "array",
    rules: [],
  },
  direction: {
    type: "string",
    rules: [
      {
        validation: "required",
      },
    ],
  },
  areaIds: {
    type: "array",
    rules: [],
  },
  siteIds: {
    type: "array",
    rules: [],
  },
  unitIds: {
    type: "array",
    rules: [],
  },
  passengerTypeId: {
    type: "number",
    rules: [],
  },
  dayGroupIds: {
    type: "array",
    rules: [],
  },
  dayTypeIds: {
    type: "array",
    rules: [],
  },
  rideTypeId: {
    type: "number",
    rules: [],
  },
  assignDocksDuringProduction: {
    type: "string",
    rules: [],
  },
  useCustomDirectionsService: {
    type: "bool",
    rules: [],
  },
  directionsService: {
    type: "string",
    rules: [],
  },
};

export const configurationFormValidationSchema = createYupSchema(
  Object.keys(configurationFormValidationRules).map((key, index) => {
    return {
      id: index,
      name: key as TConfigurationFieldName,
      isColumn: !key.includes(METADATA_KEY),
      formValidation:
        configurationFormValidationRules[key as TConfigurationFieldName],
    };
  }),
);
